/**
 * A very basic implementation of joining two paths together.
 * I have not bothered about every possible edge case here, or allowing for
 * more than 2 params, since I don't need them. Feel free to add the functionality
 * if needed.
 */
export const joinPath = (p1: string, p2: string) => {
  return `${p1.replace(/(\/)$/, "")}/${p2.replace(/^(\/)/, "")}`
}
